import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { Option } from 'carbon-react/lib/components/select';
import SimpleSelect from 'carbon-react/lib/components/select/simple-select';

interface SortByFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
}

export const SortByFilter = ({ onChange, selectedValue }: SortByFilterProps) => {
  const intl = useIntl();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Box width={200}>
      <SimpleSelect
        label={intl.formatMessage({ id: 'predict.filters.sort_by.sort_by', defaultMessage: 'Sort by' })}
        value={selectedValue}
        onChange={handleChange}
      >
        <Option
          value="date-created-newest"
          text={intl.formatMessage({
            id: 'predict.filters.sort_by.date_created_newest',
            defaultMessage: 'Date created newest'
          })}
        >
          {intl.formatMessage({
            id: 'predict.filters.sort_by.date_created_newest',
            defaultMessage: 'Date created newest'
          })}
        </Option>
        <Option
          value="date-created-oldest"
          text={intl.formatMessage({
            id: 'predict.filters.sort_by.date_created_oldest',
            defaultMessage: 'Date created oldest'
          })}
        >
          {intl.formatMessage({
            id: 'predict.filters.sort_by.date_created_oldest',
            defaultMessage: 'Date created oldest'
          })}
        </Option>
        <Option
          value="name-a-z"
          text={intl.formatMessage({ id: 'predict.filters.sort_by.name_a_z', defaultMessage: 'Name A - Z' })}
        >
          {intl.formatMessage({ id: 'predict.filters.sort_by.name_a_z', defaultMessage: 'Name A - Z' })}
        </Option>
        <Option
          value="name-z-a"
          text={intl.formatMessage({ id: 'predict.filters.sort_by.name_z_a', defaultMessage: 'Name Z - A' })}
        >
          {intl.formatMessage({ id: 'predict.filters.sort_by.name_z_a', defaultMessage: 'Name Z - A' })}
        </Option>
      </SimpleSelect>
    </Box>
  );
};
